import {INITIALISE, UserActionTypes} from './Types';
import {ThunkResult} from '../index';
import {User} from '../../Services/UserService';

export const initialiseUser = (user: User): UserActionTypes => {
  return {
    type: INITIALISE,
    payload: user,
  };
};

export const setUserCreator = (username?: string): ThunkResult<Promise<void>> => {
  return async (dispatch, getState) => {
    if (username === undefined) {
      return;
    }

    const {auth: {authorised, userService}} = getState();

    if (!authorised) {
      return;
    }

    try {
      const res = await userService.byUsername(username);
      if (res.parsedBody !== undefined) {
        dispatch(initialiseUser(res.parsedBody));
      }
    } catch (e) {
      console.log(e);
    }
  };
};
